export default __webpack_public_path__ + "static/team01-07cdf13278c8bcc1888c7540013b662e.webp";